import { render } from "./Resposta.vue?vue&type=template&id=d278e184&scoped=true"
import script from "./Resposta.vue?vue&type=script&lang=js"
export * from "./Resposta.vue?vue&type=script&lang=js"

import "./Resposta.vue?vue&type=style&index=0&id=d278e184&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d278e184"]])

export default __exports__